// extracted by mini-css-extract-plugin
module.exports = {"field":"TextfieldPage_field__vTJak","label":"TextfieldPage_label__2cMNG","scrollingPage":"TextfieldPage_scrollingPage__QgIJx"};